import Popper from "popper.js";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import i18n from "./i18n";
export default {
	install(Vue, options) {
		Vue.prototype.$tooltips = {
			pre_formatted: function (formatted_message, e) {
				if (this.popup) {
					this.popup.destroy();
					this.popup = null;
				}
				const self = this;
				let target = null;
				if (e.toElement) {
					target = e.toElement;
				} else {
					if (e.target) {
						target = e.target;
					}
				}
				let wrapper = document.createElement("div");
				var codeBlock = '<div class="helpers-wrapper" style="white-space: pre-line">' + formatted_message + "</div>";
				wrapper.innerHTML = codeBlock;
				this.popup = tippy(target, {
					content: wrapper,
					trigger: "mouseenter",
					interactive: false,
					theme: "dark",
					placement: "auto",
					delay: [100, 200],
					showOnCreate: true,
					arrow: true,
					allowHTML: true,
					popperOptions: {
						positionFixed: true,
					},
				});
			},
			pre_formatted_delay: function (formatted_message, e, delay = 600) {
				if (this.popup) {
					this.popup.destroy();
					this.popup = null;
				}
				const self = this;
				let target = null;
				if (e.toElement) {
					target = e.toElement;
				} else {
					if (e.target) {
						target = e.target;
					}
				}
				let wrapper = document.createElement("div");
				var codeBlock = '<div class="helpers-wrapper" style="white-space: pre-line">' + formatted_message + "</div>";
				wrapper.innerHTML = codeBlock;
				this.popup = tippy(target, {
					content: wrapper,
					trigger: "mouseenter",
					interactive: false,
					theme: "dark",
					placement: "auto",
					delay: [delay, 200],
					showOnCreate: true,
					arrow: true,
					popperOptions: {
						positionFixed: true,
					},
				});
			},
			/**
			 * The generalities infos of person
			 *
			 * @private
			 * @type {Object}
			 */
			popup: null,
		};
	},
};
